import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppStateService } from './app-state.service';
import { GAEvent } from '../models/google-analytics.model';
import { GAEventAction } from '../enums';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  router = inject(Router);
  appState = inject(AppStateService);

  // Any page that has a route will send a page view automatically
  public initGoogleAnalytics() {
    if (this.appState.googleAnalyticsPublicKey && this.appState.isBrowser) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          gtag('config', this.appState.googleAnalyticsPublicKey, { 'page_path': event.urlAfterRedirects });
        }
      });
    }
  }

  // Pages that are dialogs / modals will need to send a page view here
  public emitPageView(path: string) {
    if (this.appState.googleAnalyticsPublicKey && this.appState.isBrowser) {
      gtag('config', this.appState.googleAnalyticsPublicKey, { 'page_path': path });
    }
  }

  public emitEvent(eventAction: GAEventAction, event?: GAEvent) {
    if (this.appState.googleAnalyticsPublicKey && this.appState.isBrowser) {
      gtag('event', eventAction, event);
    }
  }
}
